import { commitMutation, graphql } from 'react-relay';

import { sendError } from '../appsignal';

const mutation = graphql`
  mutation RemoveOrderCouponMutation($input: RemoveOrderCouponInput!) {
    removeOrderCoupon(input: $input) {
      cart {
        paymentRequired,
        order {
          bill {
            totalBruttoPriceUnpayed
          }
        }
      }
    }
  }
`;

function commit(environment, orderId, callback) {
  return commitMutation(environment, {
    mutation,
    variables: {
      input: {
        orderId
      },
    },
    onCompleted: (response, errors) => {
      if (errors) {
        sendError(errors[0]);
        callback && callback(errors[0], null);
      } else {
        callback && callback(null, response.removeOrderCoupon.cart);
      }
    },
    onError: err => {
      sendError(err);
      callback && callback(err, null);
    },
  });
}

export default { commit };
